'use client';

import {
    DirectionEnum,
    FlexBox,
    GapSize,
    Price,
    PriceLevel,
    RadioTile,
    Tag,
    Text,
    TypographyBold,
    VariantState,
} from '@bytel/trilogy-react';

import { OptionType } from '@app-types/product';

interface ParentalRadioProps {
    option: OptionType;
    checked: boolean;
    onPress: () => void;
}

export function ParentalRadio({ option, checked, onPress }: Readonly<ParentalRadioProps>) {
    const getLabelName = () => {
        let label = 'Basique';
        const isEmpty = !option.gencode;
        if (isEmpty) {
            label = 'Pas de contrôle parental';
        } else if (option.name) {
            label = option.name.replace('remise BiG', '').trim();
        }
        return label;
    };

    const getDescription = () => {
        if (!option.gencode) {
            return null;
        }
        return (
            <FlexBox direction={DirectionEnum.COLUMN} gap={GapSize.FOUR}>
                <Text marginless>{option.cms?.description || option.pennantText}</Text>
                {option.cms?.sticker_text && (
                    <div>
                        <Tag
                            iconName={option.cms?.sticker_icon}
                            small
                            label={option.cms?.sticker_text}
                            className={option.cms?.sticker_color}
                        />
                    </div>
                )}
                <Price level={PriceLevel.SEVEN} amount={option.prices?.final ?? 0} period='mois' />
                {option.prices?.final === 0 && option.cms?.pricing_extra_info && (
                    <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>{option.cms?.pricing_extra_info}</Text>
                )}
            </FlexBox>
        );
    };

    return (
        <RadioTile
            id={option.gencode || 'no-parental-control'}
            label={option.cms?.title ?? getLabelName()}
            horizontal
            description={getDescription()}
            checked={checked}
            onChange={onPress}
            sticker={option.cms?.radio_flag}
            stickerVariant={VariantState.MAIN}
        />
    );
}
